import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CalendarConfig, CalendarFieldComponent } from '@lx/shared/ui/calendar-field';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { SelectorFieldContainerComponent } from '../selector-field-container/selector-field-container.component';
import { SidePanelComponent } from '../../layout';
import { getDateStringFromDate } from '@lx/shared/utils';
import { DialogBasedSelector } from '@lx/quote-tool/lite/shared/ui/directives';
import { DatesComponent } from '../../foundation';
import { SelectableField } from '@lx/quote-tool/lite/shared/types';

@Component({
  standalone: true,
  selector: 'lx-flexible-start-date-selector-field',
  templateUrl: './flexible-start-date-selector-field.component.html',
  styleUrls: ['./flexible-start-date-selector-field.component.scss'],
  imports: [CalendarFieldComponent, DatesComponent, SelectorFieldContainerComponent, SidePanelComponent, FormsModule, NgIf, DatesComponent],
})
export class FlexibleStartDateSelectorFieldComponent extends DialogBasedSelector<string> implements OnChanges {
  @Input() automaticOpen = false;
  @Input() disclaimer: string | undefined;
  @Input() calendarConfig: CalendarConfig | undefined;
  @Input() selectedStartDate: string | undefined;
  @Input() selectedEndDate: string | undefined;
  @Output() yearChanged = new EventEmitter<number>();

  ngOnChanges({ automaticOpen }: SimpleChanges): void {
    if (automaticOpen?.currentValue) {
      this.dialogVisible = this.automaticOpen;
    }
  }

  handleSelectedDate(date: string) {
    this.handleSelectedValue({
      value: date ? getDateStringFromDate(new Date(date)) : undefined,
      fromUser: true,
    } as SelectableField<string>);
  }
}
